import Vue from 'vue'
import Vuex from 'vuex'

import WizardModule from './modules/wizard.js';
import StaticDataModule from './modules/static.js';
import StartModule from './modules/start.js';
import CountyModule from './modules/county.js';
import DbdModule from './modules/dayByDay.js';
import TransfersModule from './modules/transfers.js';
import PassengersModule from './modules/passengers.js';
import RoomingModule from './modules/rooming.js';
import BookingModule from './modules/booking.js';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    wizard: WizardModule,
    static: StaticDataModule,
    start: StartModule,
    county: CountyModule,
    dayByDay: DbdModule,
    transfers: TransfersModule,
    passengers: PassengersModule,
    rooming: RoomingModule,
    booking: BookingModule
  },
})
